import React from 'react';
import PriceTargetsWidgetRenderer from './PriceTargetsWidgetRenderer';

const Preview: React.FC = () => (
  <PriceTargetsWidgetRenderer config={{}} />
);

export default Preview;
